<template>
  <div
    class="modal fade fixed-right modal-placement-assignments"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Placement Assignment</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="control-label">Agency</label>
            <multiselect
              :value="agencySelected"
              :options="agencies"
              track-by="id"
              placeholder
              label="name"
              :show-labels="false"
              @input="agencyWasSelected"
              :searchable="false"
            />
          </div><!-- /.form-group -->

          <div class="form-group" v-if="agencySelected">
            <label class="control-label">Manager</label>
            <multiselect
              v-model="managerSelected"
              placeholder
              :options="managers"
              :searchable="true"
              :internal-search="false"
              @search-change="debouncedSearch"
              @select="managerWasSelected"
              track-by="id"
              :show-labels="false"
              name="manager"
              :class="[errorClass('manager')]"
            >
              <template slot="noResult">
                Could not find any managers for your search.
              </template>
              <template slot="noOptions">
                There are no managers.
              </template>
              <template slot="afterList">
                <lazy-loading
                  :loading="searchingManagers"
                  :reached-bottom="getNextManagers"
                  scroll-target=".multiselect__content-wrapper"
                  ref="lazy">
                  <span slot="loading"></span>
                  <span slot="finished"></span>
                </lazy-loading>
              </template>
              <template slot="singleLabel" slot-scope="{ option }">
                <span class="dual-line">
                  {{ option.name }}
                  <br>
                  <span class="secondary">{{ option.email }}</span>
                </span>
              </template>

              <template slot="option" slot-scope="{ option }">
                <span class="dual-line">
                  {{ option.name }}
                  <br>
                  <span class="secondary">{{ option.email }}</span>
                </span>
              </template>
            </multiselect>
          </div><!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">Placement Start</label>
            <div class="input-group" :class="[validationClasses('start_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']" />
                </span>
              </span>

              <flatpickr class="form-control date-single" name="start_date" :config="dateConfig"
                :data-vv-scope="scope" data-vv-as="start date" v-validate="'required'"
                v-model="placementStartDate" />
            </div><!-- /.input-group -->
            <help-block :scope="scope" field="start_date" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">Placement End</label>
            <div class="input-group" :class="[validationClasses('end_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']" />
                </span>
              </span>
              <flatpickr class="form-control date-single" name="end_date" :config="dateConfig"
                :data-vv-scope="scope" v-validate="'required'" data-vv-as="end date"
                v-model="placementEndDate" />
            </div><!-- /.input-group -->
            <help-block :scope="scope" field="end_date" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">Start Component Open</label>
            <div
              class="input-group"
              :class="[validationClasses('start_component_open_date', scope)]"
            >
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="start_component_open_date"
                :config="dateConfig"
                v-model="placementStartComponentOpenDate"
                v-validate="'required'"
                data-vv-as="start component open date"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->
            <help-block :scope="scope" field="start_component_open_date"/>
          </div><!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">Start Component Due</label>
            <div
              class="input-group"
              :class="[validationClasses('start_component_due_date', scope)]"
            >
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="start_component_due_date"
                :config="dateConfig"
                v-model="placementStartComponentDueDate"
                data-vv-as="start component due date"
                v-validate="'required'"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->
            <help-block :scope="scope" field="start_component_due_date"/>
          </div>
          <!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">End Component Open</label>
            <div class="input-group" :class="[validationClasses('end_component_open_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="end_component_open_date"
                :config="dateConfig"
                v-model="placementEndComponentOpenDate"
                v-validate="'required'"
                data-vv-as="end component open date"
                :data-vv-scope="scope"
              />
            </div>
            <help-block :scope="scope" field="end_component_open_date"/>
          </div><!-- /.form-group -->
          <div class="form-group">
            <label class="control-label">End Component Due</label>
            <div class="input-group" :class="[validationClasses('end_component_due_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="end_component_due_date"
                :config="dateConfig"
                v-model="placementEndComponentDueDate"
                v-validate="'required'"
                data-vv-as="end component due date"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->
            <help-block :scope="scope" field="end_component_due_date"/>
          </div><!-- /.form-group -->
          <div class="row">
            <div class="col">
            </div>
            <div class="col-auto">
              <ladda-button :click="handleSaveAssignments" class="btn btn-sm btn-success">Save Changes</ladda-button>
            </div>
          </div><!-- /.row -->
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<script>
import { graduateComputed, graduateMethods, agencyComputed, agencyMethods, managerComputed, managerMethods, placementMethods } from 'vx/helpers'
import { debounce, forIn, each } from 'lodash'
import Multiselect from 'vue-multiselect'
import Flatpickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  inject: ['$validator'],
  props: {
    placement: {
      required: false,
      type: Object
    }
  },

  components: {
    Multiselect,
    Flatpickr
  },

  computed: {
    ...agencyComputed,
    ...managerComputed,
    ...graduateComputed,

    scope () {
      return 'placement'
    },

    startComponentReminderDate () {
      return moment(this.placement.start_component_due_date).subtract(1, 'weeks')
    },

    startComponentReminderDateSecond () {
      return moment(this.placement.start_component_due_date).add(1, 'days')
    },

    endComponentReminderDate () {
      return moment(this.placement.end_component_due_date).subtract(1, 'weeks')
    },

    endComponentReminderDateSecond () {
      return moment(this.placement.end_component_due_date).add(1, 'days')
    }
  },

  data () {
    return {
      agencySelected: null,
      managerSelected: null,
      search: null,
      searchingManagers: false,
      placementStartDate: null,
      placementEndDate: null,
      placementStartComponentOpenDate: null,
      placementStartComponentDueDate: null,
      placementEndComponentOpenDate: null,
      placementEndComponentDueDate: null,
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d'
      }
    }
  },

  /**
   * when placement changes populate the multiselect with any selected values
   * and get the managers appropriated to the selected agency. also open the
   * modal
   *
   */
  watch: {
    placementStartDate () {
      if (this.placement === null) {
        return
      }

      this.placement.start_date = this.placementStartDate
    },
    placementEndDate () {
      if (this.placement === null) {
        return
      }

      this.placement.end_date = this.placementEndDate
    },
    placementStartComponentOpenDate () {
      if (this.placement === null) {
        return
      }

      this.placement.start_component_open_date = this.placementStartComponentOpenDate
    },
    placementStartComponentDueDate () {
      if (this.placement === null) {
        return
      }

      this.placement.start_component_due_date = this.placementStartComponentDueDate
    },
    placementEndComponentOpenDate () {
      if (this.placement === null) {
        return
      }

      this.placement.end_component_open_date = this.placementEndComponentOpenDate
    },
    placementEndComponentDueDate () {
      if (this.placement === null) {
        return
      }

      this.placement.end_component_due_date = this.placementEndComponentDueDate
    },
    placement () {
      if (this.placement === null) {
        return
      }

      this.agencySelected = this.placement.agency
      if (this.agencySelected) {
        this.getManagers({ params: { agency: this.agencySelected.id } })
      }
      this.managerSelected = this.placement.manager

      this.placementStartDate = this.placement.start_date
      this.placementEndDate = this.placement.end_date
      this.placementStartComponentOpenDate = this.placement.start_component_open_date
      this.placementStartComponentDueDate = this.placement.start_component_due_date
      this.placementEndComponentOpenDate = this.placement.end_component_open_date
      this.placementEndComponentDueDate = this.placement.end_component_due_date

      window.$(this.$el).modal('show')
    }
  },

  async created () {
    await this.getAgencies()
  },

  /**
   * Emit closed to the GraduatesSingle component so we can unset the active
   * placement
   */
  mounted () {
    window.$(this.$el).on('hide.bs.modal', () => {
      this.$validator.reset()
      this.$emit('closed')
    })
  },

  methods: {
    ...agencyMethods,
    ...managerMethods,
    ...placementMethods,
    ...graduateMethods,

    async handleSaveAssignments () {
      let payload = {
        agency_id: this.placement.agency_id,
        manager_id: this.placement.manager_id,
        start_date: this.placement.start_date,
        end_date: this.placement.end_date,
        start_component_open_date: this.placement.start_component_open_date,
        start_component_due_date: this.placement.start_component_due_date,
        end_component_open_date: this.placement.end_component_open_date,
        end_component_due_date: this.placement.end_component_due_date
      }

      try {
        let response = await this.updateAssignments({ graduate: this.graduate.id, placement: this.placement.id, payload })
        this.setGraduatePlacement(response.data.data)
        window.$(this.$el).modal('hide')
        this.$noty.success('Save Changes succeeds')
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.renderServerErrors(error.response)
        }
        this.$noty.error('Save Changes failed')
      }
    },

    debouncedSearch: debounce(async function (search) {
      this.searchingManagers = true

      this.search = search

      await this.getManagers({ params: { search, agency: this.agencySelected.id } })

      this.$refs.lazy.$emit('reset')

      this.searchingManagers = false
    }, 800),

    /**
     * When an agency is selected set the manager to null as it should not be in
     * the new agency's list of managers
     */
    agencyWasSelected (agency) {
      this.agencySelected = agency

      this.placement.agency_id = agency
        ? agency.id
        : null

      if (this.agencySelected) {
        this.getManagers({ params: { agency: this.agencySelected.id } })
      } else {
        this.resetManagers()
      }

      this.managerWasSelected(null)
    },

    managerWasSelected (manager) {
      this.managerSelected = manager

      this.placement.manager_id = manager
        ? manager.id
        : null
    },

    async getNextManagers () {
      await this.getManagers({ params: { search: this.search, agency: this.agencySelected.id }, next: true })
    },

    isAfterNow (date) {
      let now = moment()

      if (now.isAfter(moment(date))) {
        return 'Sent'
      }

      return 'Scheduled'
    },

    isAfterNowClass (date) {
      let now = moment()

      if (now.isAfter(moment(date))) {
        return 'text-success'
      }

      return ''
    },

    renderServerErrors (response) {
      forIn(response.data.errors, (errors, name) => {
        let scope = 'placement'
        let field = this.$validator.fields.find({ name })

        field.setFlags({ invalid: true, valid: false, validated: true })

        each(errors, (msg) => {
          this.errors.add({ field: field.name, id: field.id, msg, scope })
        })
      })
    }
  }
}
</script>
